import React from "react";
import config from "../../config";

const LOGIN_BASE_URL = config.login_url;

const IFRAME_STYLE = {
  width: "100%",
  height: 35,
  border: 0
};

class FacebookLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastData: null
    };

    this._receiveMessage = this._receiveMessage.bind(this);
    this.callback = this.callback.bind(this);
  }

  componentWillMount() {
    window.addEventListener("message", this._receiveMessage, false);
  }

  componentDidMount() {
    if (this.iframe) {
      this.iframe.addEventListener("load", () => {
        this.setState({ showIframe: true });
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("message", this._receiveMessage);
  }

  _receiveMessage(e) {
    if (e.origin !== LOGIN_BASE_URL) {
      return;
    }

    this.callback(e.data);
  }

  callback(data) {
    const { success, failure } = this.props;

    if (data.error) {
      failure(data.error);
    } else if (data.status === "not_authorized") {
      failure(new Error("Unable to login to Facebook: User canceled login."));
    } else if (data.authResponse && data.authResponse.accessToken) {
      success(data.authResponse);
    } else {
      failure(new Error("Unable to login to Facebook: An error occurred."));
    }
  }

  render() {
    const label = this.props.label || "Login with Facebook";

    return (
      <div>
        <iframe
          style={Object.assign({}, IFRAME_STYLE, {
            display: this.state.showIframe ? "block" : "none"
          })}
          src={`${LOGIN_BASE_URL}/facebook_button?label=${encodeURIComponent(
            label
          )}`}
          ref={r => {
            this.iframe = r;
          }}
        />
        {!this.state.showIframe ? (
          <div
            style={Object.assign({}, IFRAME_STYLE, { position: "relative" })}
          >
            <button type="button" className="kep-login-facebook small button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1792 1792"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke="#fff"
                  fill="#fff"
                  d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"
                />
              </svg>
              &nbsp;
              {label}
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}

FacebookLogin.contextTypes = {
  router: React.PropTypes.object
};

export default FacebookLogin;



// WEBPACK FOOTER //
// ./src/app/components/partials/facebook-login.jsx